import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { useSelector } from 'react-redux';

import SortDropDown from 'app/components/shared/SortDropDown';
import Pagination from '@bibliocommons/pagination';

import PrintButton from 'app/components/shared/PrintButton';
import FacetDrawerToggle from '../../deprecated/shared/Facets/FacetDrawerToggle';
import UtilityBar from '../../shared/UtilityBar';

import './ShelfUtilityBar.scss';

export class ShelfUtilityBar extends React.PureComponent {
  render() {
    const { activeFilters, isDrawerOpen, isFetching, pagination, printURL, sortFields, drawerActions } = this.props;

    const activeFilterCount = activeFilters
      .toList()
      .flatten(true)
      .count();

    return (
      <UtilityBar className="cp-shelf-utility-bar">
        <FacetDrawerToggle drawerActions={drawerActions} activeFilterCount={activeFilterCount} />
        <SortDropDown options={sortFields} />
        <div className="pagination-and-print">
          <Pagination autoFocus={!isDrawerOpen} compact isFetching={isFetching} pagination={pagination} />
          <PrintButton url={printURL} />
        </div>
      </UtilityBar>
    );
  }
}

ShelfUtilityBar.propTypes = {
  activeFilters: ImmutablePropTypes.map.isRequired,
  isDrawerOpen: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  pagination: ImmutablePropTypes.map.isRequired,
  printURL: PropTypes.string.isRequired,
  sortFields: ImmutablePropTypes.list,
  drawerActions: PropTypes.objectOf(PropTypes.func).isRequired
};

const ShelfUtilityBarContainer = props => {
  const isDrawerOpen = useSelector(state => state.getIn(['drawer', 'open'])) ?? false;

  return <ShelfUtilityBar {...props} isDrawerOpen={isDrawerOpen} />;
};

export default ShelfUtilityBarContainer;
